import { useLazyQuery } from '@apollo/client';
import * as Sentry from '@sentry/react';

import UserIdAndExternalId from 'bundles/onboarding-common/queries/UserIdAndExternalId.graphql';
import type { UserIdAndExternalIdQuery } from 'bundles/onboarding-common/queries/__generated__/UserIdAndExternalId';

const useFetchUserIdAndExternalId = () => {
  const [fetchData] = useLazyQuery<UserIdAndExternalIdQuery>(UserIdAndExternalId, {
    errorPolicy: 'all',
    context: {
      clientName: 'gatewayGql',
    },
  });

  const fetchUserIdAndExternalId = async () => {
    try {
      const { data, error } = await fetchData();

      const id = data?.User?.me?.id;
      const externalId = data?.User?.me?.externalId;

      if (error || !id || !externalId) {
        Sentry.captureMessage('Error fetching user id and external id', {
          extra: {
            error: error?.message,
          },
        });
        return null;
      }

      return {
        userId: Number(id),
        externalId,
      };
    } catch (error) {
      Sentry.captureMessage('Error fetching user id and external id', {
        extra: {
          error: error.message,
        },
      });
      return null;
    }
  };

  return { fetchUserIdAndExternalId };
};

export default useFetchUserIdAndExternalId;
